import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tab-stat-pills" }
const _hoisted_2 = {
  key: 1,
  class: "tab-stat-pills__value"
}

import Skeleton from 'primevue/skeleton';

export interface TabStat {
    id: string
    label: string
    value: string | number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TabStatPills',
  props: {
    stats: {},
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

/* eslint-env vue/setup-compiler-macros */


function syncTruncationTooltip(event: Event) {
    const label = event.target as HTMLElement;
    const isTruncated = label.scrollWidth > label.clientWidth;

    label.title = isTruncated ? label.textContent?.trim() ?? '' : '';
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.stats, (stat) => {
      return (_openBlock(), _createElementBlock("div", {
        key: stat.id,
        class: "tab-stat-pills__pill"
      }, [
        _createElementVNode("span", {
          class: "tab-stat-pills__label",
          onMouseenter: syncTruncationTooltip,
          onFocusin: syncTruncationTooltip
        }, _toDisplayString(stat.label), 33),
        (__props.loading)
          ? (_openBlock(), _createBlock(_unref(Skeleton), {
              key: 0,
              width: "72px",
              height: "17px",
              "border-radius": "4px"
            }))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(stat.value), 1))
      ]))
    }), 128))
  ]))
}
}

})